import { BareActionContext } from 'vuex-typex'
import { FeedState } from '../state'
import { RootState } from '../..'
import viewStatements from './view-statements'
import authStore from '../../auth/auth-store'
import setFeedUser from '@/store/feed/actions/set-feed-user';
import { IUser } from '@/model/user';

export default async function viewMyStatements(context: BareActionContext<FeedState, RootState>)
{
  setFeedUser(context, <IUser>authStore.user)
  viewStatements(context)

  return
}
